import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    console.log("[popover] Controller connected")

    // Select any element with this custom attribute — can be anywhere
    this.triggerElement = document.querySelector('[data-popover-trigger]')
    if (!this.triggerElement) {
      console.warn("[popover] No trigger element found in document")
      return
    }

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          console.log("[popover] Intersection observed:", {
            isIntersecting: entry.isIntersecting,
            top: entry.boundingClientRect.top,
          })

          if (entry.isIntersecting && entry.boundingClientRect.top <= 0) {
            console.log("[popover] Trigger touched top of viewport — showing modal")
            this.show()
          }
        })
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -100% 0px',
      }
    )

    this.observer.observe(this.triggerElement)
    console.log("[popover] Observer attached to external trigger")
  }

  disconnect() {
    if (this.observer && this.triggerElement) {
      this.observer.unobserve(this.triggerElement)
      console.log("[popover] Observer disconnected")
    }
  }

  show() {
    console.log("[popover] Showing modal")
    this.element.classList.remove("opacity-0", "pointer-events-none", "scale-95")
    this.element.classList.add("opacity-100", "scale-100")
  }

  close() {
    console.log("[popover] Closing modal")
    this.element.classList.add("opacity-0", "pointer-events-none", "scale-95")
    this.element.classList.remove("opacity-100", "scale-100")
  }
}
